export default "__VITE_ASSET__t6oO69Wv__"